import { render, staticRenderFns } from "./amountList.vue?vue&type=template&id=306975d6&scoped=true&"
import script from "./amountList.vue?vue&type=script&lang=ts&"
export * from "./amountList.vue?vue&type=script&lang=ts&"
import style0 from "./amountList.vue?vue&type=style&index=0&id=306975d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306975d6",
  null
  
)

export default component.exports